<template>
  <aside class="sidebar">
    <el-menu
      background-color="#00000000"
      :default-active="$route.name"
      router
    >
      <template v-for="item in menuItems">
        <el-submenu
          v-if="item.subItems && item.subItems.length"
          :index="item.index"
          :key="item.index"
        >
          <template slot="title">
            <div class="item-icon" v-if="item.icon">
              <font-awesome-icon :icon="item.icon"/>
            </div>
            <span>{{ item.label }}</span>
          </template>

          <template v-for="subItem in item.subItems">
            <el-menu-item
              :index="subItem.index"
              :route="subItem.route"
              :key="subItem.index"
            >
              <span>{{ subItem.label }}</span>
            </el-menu-item>
          </template>
        </el-submenu>

        <el-menu-item
          v-else
          :index="item.index"
          :route="item.route"
          :key="item.index"
        >
          <div class="item-icon" v-if="item.icon">
            <font-awesome-icon :icon="item.icon"/>
          </div>
          <span>{{ item.label }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </aside>
</template>

<script>
export default {
  name: 'TheSidebar',
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  }
}
</script>
